import ReactGA from 'react-ga'

exports.onClientEntry = () => {
  ReactGA.initialize('UA-58551299-2')
}

exports.onRouteUpdate = ({ location }) => {
  if (process.env.NODE_ENV === `production` && typeof ga === `function`) {
    ReactGA.pageview((location || {}).pathname)
  }
}



// WEBPACK FOOTER //
// ./gatsby-browser.js